import React from 'react';
import { seasonNames } from 'resources/common-values';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import CreateReactClass from 'create-react-class';
const noStudiesKey = 'NoLinkingStudies';
import HelpBox from 'components/generic/help/index';
import NoProjectionsHelpText from './no-projections-help-text';

export default CreateReactClass({
    displayName: 'ComparisonsNormalProficiency',

    propTypes: {
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        proficienciesToDisplay: PropTypes.instanceOf(Immutable.List),
    },

    getProjection(study, subjectName) {
        if (study) {
            const seasonNumber = study.get('seasonNumber', null);
            const season = seasonNumber ? seasonNames[seasonNumber].name.toLowerCase() : null;
            const rowkey = study.get('study');
            return (
                <div
                    className="comparisons-projection-row-normal"
                    key={rowkey}
                    id={`comparisons-projection-row-normal-${subjectName}-${this.props.studentBid}-${rowkey}`}
                >
                    <div className="projection-category-normal">{study.getIn(['proficiency', 'category'])}</div>
                    <div className="projection-detail-normal">
                        <div className="projection-detail-study">{study.get('studyDisplayName')}</div>
                        <div className="projection-detail-window">
                            If taken in the <span className="comparisons-projection-season">{season}</span>
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    },

    helpText() {
        return <NoProjectionsHelpText />;
    },

    getProjections(subjectName) {
        let projections = [];
        if (this.props.proficienciesToDisplay) {
            this.props.proficienciesToDisplay.forEach((proficiency) => {
                projections.push(this.getProjection(proficiency, subjectName));
            });
        }

        if (projections.length === 0) {
            //Push on the empty projections div
            projections.push(
                <div
                    className="comparisons-projection-row-no-linking-studies-normal no-linking-studies"
                    key={noStudiesKey}
                >
                    {CommonStrings.comparisonsProjectionsNotAvailable}
                    <HelpBox
                        id={'comparisons-projections-normal-no-linking-studies-' + this.props.studentBid}
                        appLevelCssClassName="show-comparisons-projections-normal-no-projections"
                        helpContentsRenderer={this.helpText}
                        moduleName={CommonValues.SectionIDs.comparisons}
                        helpLabel="comparisons-projections-expanded-no-projections-help"
                        optionalText="Why?"
                        renderIcon={false}
                    />
                </div>
            );
        }

        return projections;
    },

    getAdditionalHeading(projections) {
        if (!(projections.length === 1 && projections[0].key === noStudiesKey)) {
            return (
                <span className="comparisons-heading-additional projections">
                    {CommonStrings.comparisonsProjectionsProjectedResults}
                </span>
            );
        }
        return null;
    },

    render() {
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        const projections = this.getProjections(subjectName);
        const linkingStudiesHeading = this.getAdditionalHeading(projections);
        return (
            <div className="data-row" id={`comparisons-proficiencies-normal-${subjectName}-${this.props.studentBid}`}>
                <h3 className="comparisons-heading">
                    PROJECTIONS
                    {linkingStudiesHeading}
                </h3>
                {projections}
            </div>
        );
    },
});
